import React from 'react';
import { SaleStatusCssClasses, SaleStatusTitles } from './../../SalesUIHelpers';

export function StatusColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `label label-lg label-${
      SaleStatusCssClasses[row.status]
    } label-inline`;
  };
  return (
    <span className={getLabelCssClasses()}>{SaleStatusTitles[row.status]}</span>
  );
}
